import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  main1: '#FFD16A', // 노랑
  main2: '#DF463A', // 빨강
  main3: '#3F79B2', // 파랑
  main4: '#31725c', // 청록
  main5: '#46548F', // 보라
  main6: '#347437', // 초록
};
